const windowGlobal = typeof window !== 'undefined' && window.dataLayer;

const dataLayer = windowGlobal || [];

const pageView = (path, pageTitle) => {
	return dataLayer.push({
		event: 'pageView',
		pagePath: path,
		pageTitle: pageTitle
	});
};
export const formReserve = formStage => {
	return dataLayer.push({
		event: 'reserve',
		stage: formStage
	});
};
export const formContact = formStage => {
	return dataLayer.push({
		event: 'contact',
		submitted: formStage
	});
};
export const clickLinks = link => {
	return dataLayer.push({
		event: 'ClickLinksDatalayer',
		ExternalLinks: link
	});
};

export default pageView;


// WEBPACK FOOTER //
// ./src/gtm/index.js